import ReferralProviderCard from './ReferralProviderCard';

export default ReferralProviderCard;
